import { FaEdit, FaTrash, FaCalendar } from "react-icons/fa";
import useCadastroPatrocinador from "../../hooks/useCadastroPatrocinadorContext";
import { formatarDia } from "../../services/conversaoTimer";
import { Link } from "react-router-dom";

const LinhaPatrocinador = (props) => {
  const { participantes, setParticipantes } = useCadastroPatrocinador();

  const handleExcluirParticipante = (id) => {
    let filter = participantes.filter((p) => {
      return p.id !== id;
    });
    setParticipantes(filter);
  };

  return (
    <div className="linha-participantes">
      <div data-label="Nome Completo">{props.participante?.nome}</div>
      <div className="nome-cracha" data-label="Nome Crachá">{props.participante?.nome_cracha}</div>
      <div className="email" data-label="E-mail">{props.participante.email}</div>
      <div data-label="Opções">
        <div className="area-botoes-participantes">
          <button
            className="btn-header-options"
            onClick={() => props.onEditar && props.onEditar(props.participante)}
            title="Editar participante"
          >
            <FaEdit /> Editar
          </button>
        </div>
      </div>
    </div>
  );
};
export default LinhaPatrocinador;
